import type { SVGProps } from "react";
export interface BookHeartIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BookHeartIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BookHeartIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.875 4A.876.876 0 0 0 18 3.125H7c-1.036 0-1.875.84-1.875 1.875v12.002c.278-.081.57-.127.875-.127h12a.877.877 0 0 0 .875-.876zM5.143 20.176a.875.875 0 0 0 .857.699h11.875v-1.75H6a.875.875 0 0 0-.875.875zM21.125 16c0 .904-.386 1.715-1 2.286v2.596a1.126 1.126 0 0 1-.01 2.237l-.114.006H6a3.125 3.125 0 0 1-3.109-2.806L2.875 20V5A4.125 4.125 0 0 1 7 .875h11A3.126 3.126 0 0 1 21.125 4z"
      />
      <path
        fill={color}
        d="M13.957 5.375c.936 0 1.747.48 2.29 1.102a3.52 3.52 0 0 1 .873 2.408l.002.001c-.037 1.226-.759 2.166-1.42 2.852l-.278.28c-.49.48-.96.924-1.365 1.3l-.98.897a1.615 1.615 0 0 1-2.04.098l-.118-.098a75 75 0 0 1-1.633-1.508l-.715-.689c-.719-.703-1.656-1.73-1.698-3.132l.001-.001a3.53 3.53 0 0 1 .875-2.408c.543-.623 1.353-1.102 2.288-1.102.866 0 1.5.308 1.959.688.458-.38 1.093-.688 1.96-.688Zm0 2.25c-.293 0-.459.102-.587.229a1.4 1.4 0 0 0-.202.26l-.157.295v.001l-.025.044a1 1 0 0 1-.208.27q-.03.03-.063.06a1 1 0 0 1-.145.104l-.022.011q-.03.018-.06.034a1.1 1.1 0 0 1-.38.103 1.1 1.1 0 0 1-.321-.015 1 1 0 0 1-.156-.038q-.003 0-.005-.002a1.1 1.1 0 0 1-.41-.26 1.1 1.1 0 0 1-.182-.223l-.018-.03-.03-.058c-.098-.203-.202-.4-.358-.555-.128-.127-.295-.229-.589-.229-.148 0-.377.084-.593.331a1.3 1.3 0 0 0-.32.747l-.002.113v.003l.019.161c.073.38.372.813 1.003 1.43l.693.668c.439.417.84.784 1.159 1.075a74 74 0 0 0 1.853-1.743l.25-.254c.539-.567.761-.969.772-1.337v-.003l-.003-.113a1.3 1.3 0 0 0-.32-.747c-.215-.247-.445-.331-.593-.331Z"
      />
    </svg>
  );
}
